import * as R from "ramda";

export const flattenFormGroupObject = (controls) => {
  return Object.keys(controls).reduce((obj, key) => {
    obj[key] = controls[key].value;
    return obj;
  }, {});
};

export const mapToSelectOption = (value) => ({
  label: value,
  value: value,
});

export const mapToObjectDDL = (label, value) => ({
  label: label,
  value: value,
});

export const mapToDDL = (label, value) => {
  if (!R.isNil(label) && !R.isNil(value) && !R.isEmpty(label) && !R.isEmpty(value)) {
      return {
          label: label,
          value: value
      };
  } else {
      return [];
  }
};

export const getValueFromDDL = (object, key) => {
  if (object?.[key] === undefined || R.isNil(object?.[key]) || R.isEmpty(object?.[key])) return "";
  return object[key].value;
};

export const getValueFromArrayDDL = (object, key) => {
    if (object?.[key] === undefined || R.isNil(object[key]) || R.isEmpty(object[key])) {
        return [];
    }

    return Array.isArray(object[key].value)
        ? object[key].value.map((item) => item.value)
        : [];
};

export const removeNullFields = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== null && !R.isEmpty(obj[key]) && (obj[key] !== undefined)) {
        if (typeof obj[key] === "string") {
            acc[key] = obj[key].trim();
        } else {
            acc[key] = obj[key];
        }
    }
    return acc;
  }, {});
};

export const removeEmptyFilterGroups = (filters) => {
  if (!filters) return {};

  let cleaned = {};

  Object.keys(filters).forEach((groupKey) => {
    const group = filters[groupKey];
    if (R.isNil(group) || R.isEmpty(group)) return;

    const cleanedGroup = {};

    Object.keys(group).forEach((key) => {
      const value = group[key];
      if (R.isNil(value)) return;
      if (R.is(Array, value) && value.length === 0) return;
      if (R.is(Object, value) && R.isEmpty(value)) return;

      cleanedGroup[key] = value;
    });

    if (!R.isEmpty(cleanedGroup)) {
      cleaned[groupKey] = cleanedGroup;
    }
  });

  return cleaned;
};
